import React, { useEffect } from "react";
import { Form, Checkbox, Radio, Input, Row, Col, message } from "antd";

const Section4 = ({
  formValues,
  setFormValues,
  validationErrors,
  setValidationErrors,
}) => {
const selectedServices = [
  ...(formValues.creativeProduction || []),
  ...(formValues.digitalMarketing || []),
  ...(formValues.advertisingChannels || []),
  ...(formValues.publicEngagement || []),
];

const uniqueServices = Array.from(new Set(selectedServices));

 const coreSpecialtyOptions = uniqueServices
    .slice()
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }))
    .includes("Other (please specify)")
    ? uniqueServices
    : [...uniqueServices, "Other (please specify)"];

  const half = Math.ceil(coreSpecialtyOptions.length / 2);
  const left = coreSpecialtyOptions.slice(0, half);
  const right = coreSpecialtyOptions.slice(half);

  const handleCoreSpecialtyChange = (checkedValues) => {
    if (checkedValues.length > 5) {
      message.warning("⚠️ You can select up to 5 core specialties only.");
      return;
    }
    setFormValues({ ...formValues, coreSpecialties: checkedValues });
  };

  useEffect(() => {
    const selectedServices = [
      ...(formValues.creativeProduction || []),
      ...(formValues.digitalMarketing || []),
      ...(formValues.advertisingChannels || []),
      ...(formValues.publicEngagement || []),
    ];

    const invalidSelections = (formValues.coreSpecialties || []).filter(
      (specialty) =>
        specialty !== "Other (please specify)" &&
        !selectedServices.includes(specialty)
    );

    if (invalidSelections.length > 0) {
      setValidationErrors((prev) => ({
        ...prev,
        coreSpecialties:
          "Some selected specialties weren’t chosen in Section 3 services. Please review.",
      }));
    } else {
      setValidationErrors((prev) => ({
        ...prev,
        coreSpecialties: null,
      }));
    }
  }, [
    formValues.coreSpecialties,
    formValues.creativeProduction,
    formValues.digitalMarketing,
    formValues.advertisingChannels,
    formValues.publicEngagement,
  ]);

  return (
    <Form layout="vertical">
      {/*Core Specialties */}
      <Form.Item label="17. Of the services you selected above, which 5 are your core specialties? (Select up to 5)">
        <Checkbox.Group
          // disabled={coreSpecialtyOptions.length === 0}
          value={formValues.coreSpecialties || []}
          onChange={handleCoreSpecialtyChange}
          style={{ width: "100%" }}
        >
          <Row gutter={[24, 8]}>
            <Col xs={24} md={12}>
              {left.map((label) => (
                <div key={label} style={{ marginBottom: 8 }}>
                  <Checkbox value={label}>{label}</Checkbox>
                </div>
              ))}
            </Col>
            <Col xs={24} md={12}>
              {right.map((label) => (
                <div key={label} style={{ marginBottom: 8 }}>
                  <Checkbox value={label}>{label}</Checkbox>
                </div>
              ))}
            </Col>
          </Row>
        </Checkbox.Group>

        {/* Validation message */}
        {validationErrors?.coreSpecialties && (
          <div style={{ color: "red", fontWeight: "bold", marginTop: "8px" }}>
            {validationErrors.coreSpecialties}
          </div>
        )}
      </Form.Item>

      {/* Other (if selected) */}
      {formValues.coreSpecialties?.includes("Other (please specify)") && (
        <Form.Item label="Please specify your other specialty">
          <Input
            placeholder="Enter additional specialty"
            value={formValues.otherCoreSpecialty || ""}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                otherCoreSpecialty: e.target.value,
              })
            }
          />
        </Form.Item>
      )}

      {/* Follow-up: Comfort matching for services */}
      <Form.Item label=" 18. Would you be comfortable being matched primarily for the services you selected above?">
        <Radio.Group
          value={formValues.matchComfort}
          onChange={(e) =>
            setFormValues({ ...formValues, matchComfort: e.target.value })
          }
        >
          <Radio value="Yes">Yes</Radio>
          <Radio value="No">No</Radio>
          <Radio value="Depends">Depends (please explain)</Radio>
        </Radio.Group>
      </Form.Item>

      {/* If Depends → explanation */}
      {formValues.matchComfort === "Depends" && (
        <Form.Item label="Please explain your answer">
          <Input.TextArea
            placeholder="Explain under what conditions you’d accept being matched."
            value={formValues.matchComfortExplanation || ""}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                matchComfortExplanation: e.target.value,
              })
            }
          />
        </Form.Item>
      )}

      {/* Campaign Execution Type */}
      <Form.Item label="19. Do you manage full campaign execution, or only place media buys?">
        <Radio.Group
          value={formValues.campaignExecution}
          onChange={(e) =>
            setFormValues({ ...formValues, campaignExecution: e.target.value })
          }
        >
          <Radio value="Full">We manage full campaign execution</Radio>
          <Radio value="Media Buys Only">We primarily place media buys</Radio>
          <Radio value="Both">We do both depending on the project</Radio>
          <Radio value="Neither">Neither</Radio>
        </Radio.Group>
      </Form.Item>

      {/* Average Campaign Lead Time */}
      <Form.Item label="20. What is your average campaign lead time from intake to launch?">
        <Radio.Group
          value={formValues.leadTime}
          onChange={(e) =>
            setFormValues({ ...formValues, leadTime: e.target.value })
          }
        >
          <Radio value="Less than 1 week">Less than 1 week</Radio>
          <Radio value="1-2 weeks">1-2 weeks</Radio>
          <Radio value="3-4 weeks">3-4 weeks</Radio>
          <Radio value="1-2 months">1-2 months</Radio>
          <Radio value="More than 2 months">More than 2 months</Radio>
          <Radio value="Varies significantly">
            It varies significantly by project
          </Radio>
          <Radio value="Not sure">
            Not sure / we don't manage campaign launches
          </Radio>
        </Radio.Group>
      </Form.Item>
    </Form>
  );
};

export default Section4;
